@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../constants/spacing.module.less';

.container {
  padding: @space-16;
  background-color: var(--white);
}

.section-title {
  margin-bottom: @space-16;
  font-weight: 500;
}

.summary {
  display: flex;
  justify-content: space-between;
  margin-bottom: @space-16;
}

.summary-text {
  font-size: 14px;
}

.table-container {
  margin-bottom: @space-16;
  margin-top: @space-16;
  overflow-x: auto;
  border: 1px solid var(--gray-DFE4E8);
  border-radius: 4px;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.empty-row-text {
  padding: @space-40 @space-0;
  align-self: stretch;
  color: var(--grey-600);
  text-align: center;
}
